function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapitalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 403.911 317.769",
    style: {
      enableBackground: "new 0 0 403.911 317.769"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M236.657 209.347H52.485c-4.14 0-7.5 3.359-7.5 7.5v32.801c0 4.14 3.36 7.5 7.5 7.5h184.172c4.141 0 7.5-3.36 7.5-7.5v-32.801c0-4.141-3.359-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7944b2"
    },
    d: "M236.657 209.347h-92.086v47.801h92.086c4.141 0 7.5-3.36 7.5-7.5v-32.801c0-4.141-3.359-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M204.79 113.745H20.618c-4.141 0-7.5 3.36-7.5 7.5v32.801c0 4.141 3.359 7.5 7.5 7.5H204.79c4.14 0 7.5-3.359 7.5-7.5v-32.801c0-4.14-3.36-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7944b2"
    },
    d: "M204.79 113.745h-92.086v47.801h92.086c4.14 0 7.5-3.359 7.5-7.5v-32.801c0-4.14-3.36-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M212.755 18.144H28.583a7.501 7.501 0 0 0-7.5 7.5v32.8c0 4.141 3.359 7.5 7.5 7.5h184.172c4.14 0 7.5-3.359 7.5-7.5v-32.8c0-4.141-3.36-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7944b2"
    },
    d: "M212.755 18.144h-92.086v47.8h92.086a7.5 7.5 0 0 0 7.5-7.5v-32.8c0-4.141-3.36-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M204.79 257.148H20.618a7.501 7.501 0 0 0-7.5 7.5v32.8c0 4.141 3.359 7.5 7.5 7.5H204.79c4.14 0 7.5-3.359 7.5-7.5v-32.8c0-4.141-3.36-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M204.79 257.148h-92.086v47.8h92.086c4.14 0 7.5-3.359 7.5-7.5v-32.8c0-4.141-3.36-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M220.723 161.546H36.552a7.501 7.501 0 0 0-7.5 7.5v32.801c0 4.14 3.359 7.5 7.5 7.5h184.171c4.141 0 7.5-3.36 7.5-7.5v-32.801c0-4.141-3.359-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M220.723 161.546h-92.085v47.801h92.085c4.141 0 7.5-3.36 7.5-7.5v-32.801c0-4.141-3.359-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M228.688 65.944H44.516c-4.14 0-7.5 3.36-7.5 7.5v32.801c0 4.141 3.36 7.5 7.5 7.5h184.172c4.141 0 7.5-3.359 7.5-7.5V73.444c0-4.14-3.359-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M228.688 65.944h-92.086v47.801h92.086c4.141 0 7.5-3.359 7.5-7.5V73.444c0-4.14-3.359-7.5-7.5-7.5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M397.118 193.413c0 61.602-49.938 111.535-111.535 111.535-61.602 0-111.535-49.933-111.535-111.535 0-61.597 49.933-111.535 111.535-111.535 61.597 0 111.535 49.938 111.535 111.535zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M285.583 81.878v223.07c61.597 0 111.535-49.937 111.535-111.535 0-61.597-49.938-111.535-111.535-111.535zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M299.509 185.273a309.827 309.827 0 0 1-6.649-2.422v-37.106c3.043.582 5.988 1.965 8.246 4.699a7.966 7.966 0 0 0 11.215 1.075 7.965 7.965 0 0 0 1.074-11.215c-2.257-2.738-8.89-9.406-20.535-10.707v-6.199a7.966 7.966 0 0 0-7.969-7.965 7.965 7.965 0 0 0-7.964 7.965v7.683c-1.18.324-2.383.688-3.625 1.117-11.215 3.891-19.438 13.786-21.45 25.828-1.777 10.622 1.668 20.497 9.211 26.415 4.032 3.16 9.032 6.05 15.864 9.101v45.824c-6.039-.468-9.887-1.965-16.461-6.265a7.967 7.967 0 0 0-8.723 13.332c9.824 6.425 16.559 8.383 25.184 8.894v8.102a7.965 7.965 0 0 0 7.964 7.965 7.966 7.966 0 0 0 7.969-7.965v-8.781c6.633-1.375 12.653-4.438 17.692-9.067 6.293-5.781 10.543-13.621 11.961-22.062 2.902-17.266-6.129-32.278-23.004-38.246zm-28.61-13.372c-2.886-2.265-4.133-6.468-3.332-11.25.754-4.523 3.617-10.035 9.36-12.738v27.879c-2.262-1.246-4.309-2.543-6.028-3.891zm35.899 48.977c-1.157 6.887-5.895 14.203-13.938 17.23v-38.289c.446.161.879.317 1.336.477 14.067 4.973 13.203 17.008 12.602 20.582zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7944b2"
    },
    d: "M299.509 185.273a309.827 309.827 0 0 1-6.649-2.422v-37.106c3.043.582 5.988 1.965 8.246 4.699a7.966 7.966 0 0 0 11.215 1.075 7.965 7.965 0 0 0 1.074-11.215c-2.257-2.738-8.89-9.406-20.535-10.707v-6.199c0-4.164-3.203-7.582-7.277-7.93v155.89a7.96 7.96 0 0 0 7.277-7.929v-8.781c6.633-1.375 12.653-4.438 17.692-9.067a38.856 38.856 0 0 0 11.961-22.062c2.902-17.266-6.129-32.278-23.004-38.246zm7.289 35.605c-1.157 6.887-5.895 14.203-13.938 17.23v-38.289c.446.161.879.317 1.336.477 14.067 4.973 13.203 17.008 12.602 20.582zm0 0"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitalIcon);
export default __webpack_public_path__ + "static/media/capitalIcon.551530a501cb6a46e5c99473ee312c03.svg";
export { ForwardRef as ReactComponent };